import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EntityMembershipPolicies } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { MEMBERSHIP_POLICIES_QUERY_KEY } from "./useMembershipPolicies";
const deleteMembershipPolicy = async ({ id }) => EntityMembershipPolicies.remove(id);
const createMembershipPolicy = async (payload) => {
  var _a;
  const { share_request, entity } = payload;
  return EntityMembershipPolicies.create({
    entity,
    share_request: {
      selected_grantee_capabilities: (_a = share_request == null ? void 0 : share_request.selected_grantee_capabilities) == null ? void 0 : _a.toJS(),
      selected_collections: share_request == null ? void 0 : share_request.selected_collections
    }
  });
};
const useMembershipPoliciesMutations = () => {
  const queryClient = useQueryClient();
  const create = useMutation({
    mutationFn: createMembershipPolicy,
    onError: (errorThrown) => {
      UserNotification.error(
        `Creating Membership policy failed with status: ${errorThrown}`,
        "Could not create Membership policy"
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEMBERSHIP_POLICIES_QUERY_KEY] });
    }
  });
  const remove = useMutation({
    mutationFn: deleteMembershipPolicy,
    onError: (errorThrown) => {
      UserNotification.error(
        `Removing Membership policy failed with status: ${errorThrown}`,
        "Could not remove Membership policy"
      );
    },
    onSuccess: () => {
      UserNotification.success("Membership policy has been successfully removed.", "Success!");
      queryClient.invalidateQueries({ queryKey: [MEMBERSHIP_POLICIES_QUERY_KEY] });
    }
  });
  return {
    removeMembershipPolicy: remove.mutateAsync,
    createMembershipPolicy: create.mutateAsync
  };
};
export default useMembershipPoliciesMutations;
